import { IconHeart } from "@tine/designsystem-icons/sharp";
import { observer } from "mobx-react-lite";

import useMediaQuery from "../common/useMediaQuery";
import { mediaQueries } from "../common/utils";

import Button from "./Button";

const FavoriteListButton = () => {
   const isXl = useMediaQuery(mediaQueries.xl);
   return (
      <Button
         to="/customer/favorites"
         iconPosition="left"
         size={isXl ? "regular" : "iconOnly"}
         variant="tertiary"
         icon={<IconHeart />}
         aria-label="favorittlister"
         trackingName="Favorittlister"
         data-testid="go-to-favorite-list-menu-button"
      >
         Favorittlister
      </Button>
   );
};

export default observer(FavoriteListButton);
